export default "__VITE_ASSET__e716127a__"